import { render, staticRenderFns } from "./AddressSettings.vue?vue&type=template&id=350896f5&"
import script from "./AddressSettings.vue?vue&type=script&lang=ts&"
export * from "./AddressSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports